<p-toast position="top-right"></p-toast>

<!-- Membrete de Rendafin: invisible en pantalla, es lo que encabeza el documento impreso. -->
<app-print-header
  *ngIf="doc"
  [title]="doc.title"
  [subtitle]="doc.subtitle"
  [meta]="'v' + doc.version + ' · actualizado ' + (doc.updatedAt | date: 'd MMM y')">
</app-print-header>

<div class="doc-layout" [class.with-panel]="panelOpen" [class.toc-open]="tocOpen">

  <!-- ─────────── índice del documento ─────────── -->
  <aside class="doc-toc">
    <nav class="doc-toc__inner">
      <p class="doc-toc__title">{{ doc?.kind === 'guia' ? 'En esta guía' : 'En este manual' }}</p>

      <ng-container *ngIf="loading; else tocCargado">
        <div class="sk-line sk-toc" *ngFor="let ancho of skeletonToc" [style.width.%]="ancho"></div>
      </ng-container>

      <ng-template #tocCargado>
        <a *ngFor="let entry of toc; trackBy: trackByToc"
           class="doc-toc__link"
           [class.is-active]="entry.id === activeSection"
           (click)="scrollTo(entry.id)">{{ entry.label }}</a>
      </ng-template>
    </nav>
  </aside>

  <!-- ─────────── contenido ─────────── -->
  <section class="doc-main">
    <header class="doc-head" *ngIf="doc">
      <button type="button" class="doc-icon-btn" (click)="toggleToc()" [title]="tocOpen ? 'Ocultar índice' : 'Mostrar índice'">
        <i class="fa-solid" [ngClass]="tocOpen ? 'fa-outdent' : 'fa-indent'"></i>
      </button>

      <div class="doc-head__title">
        <h1>{{ doc.title }}</h1>
        <p>
          {{ doc.subtitle }}
          <span class="doc-head__meta">· v{{ doc.version }} · actualizado {{ doc.updatedAt | date: 'd MMM y' }}</span>
        </p>
      </div>

      <!-- Conmutador teoría ↔ práctica. Conserva la sección, así que se cambia de vista
           sin perder el punto que se venía leyendo. -->
      <div class="doc-switch" *ngIf="companion">
        <span class="doc-switch__item is-active">{{ doc.toggleLabel }}</span>
        <button type="button" class="doc-switch__item" (click)="goToCompanion()"
                [title]="'Ver ' + companion.title">{{ companion.toggleLabel }}</button>
      </div>

      <div class="doc-head__actions">
        <!-- El avance hacia lo que de verdad le pedimos a Contabilidad. Dos números porque son
             dos metas: contestar es de ellos, cerrar es nuestro. -->
        <button type="button" class="doc-progress" *ngIf="progress.total" (click)="openDecisions()"
                [class.is-done]="progress.answered === progress.total"
                [title]="progress.closed + ' de ' + progress.total + ' cerradas por nosotros'">
          <span class="doc-progress__bar"><i [style.width.%]="progress.answered / progress.total * 100"></i></span>
          <span class="doc-progress__text">Decisiones <b>{{ progress.answered }}/{{ progress.total }}</b></span>
        </button>

        <button type="button" class="doc-btn" (click)="print()">
          <i class="fa-solid fa-print"></i> Imprimir
        </button>
        <button type="button" class="doc-btn doc-btn--primary" (click)="openAll()">
          <i class="fa-solid fa-comments"></i> Comentarios
          <span class="doc-btn__count" *ngIf="openCount">{{ openCount }}</span>
        </button>
      </div>
    </header>

    <!-- Esqueleto con la forma real con la que abren los manuales: encabezado de sección,
         fila de indicadores, dos avisos y una tabla. Ocupa el mismo lugar que ocupará el
         contenido, así que al llegar no salta nada. -->
    <div class="doc-skeleton" *ngIf="loading" aria-hidden="true">
      <div class="sk-rule"></div>
      <div class="sk-line sk-title"></div>

      <div class="sk-grid">
        <div class="sk-kpi" *ngFor="let card of skeletonCards">
          <div class="sk-line sk-kpi__label"></div>
          <div class="sk-line sk-kpi__value"></div>
          <div class="sk-line sk-kpi__note"></div>
        </div>
      </div>

      <div class="sk-boxes">
        <div class="sk-box" *ngFor="let box of [1, 2]">
          <div class="sk-line sk-box__tag"></div>
          <div class="sk-line"></div>
          <div class="sk-line" style="width:72%"></div>
        </div>
      </div>

      <div class="sk-line sk-subtitle"></div>

      <div class="sk-table">
        <div class="sk-table__head"></div>
        <div class="sk-table__row" *ngFor="let row of skeletonRows"></div>
      </div>
    </div>

    <div class="doc-state doc-state--error" *ngIf="!loading && loadError">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <p>{{ loadError }}</p>
    </div>

    <!-- El manual se lee igual sin comentarios, pero hay que decirlo: si no, quien
         escribió uno creería que se perdió. -->
    <div class="doc-notice" *ngIf="!loading && !loadError && threadsError">
      <i class="fa-solid fa-comment-slash"></i>
      <span>No se pudieron cargar los comentarios. El manual se lee completo; vuelve a intentarlo recargando la página.</span>
    </div>

    <!-- El lienzo se mantiene en el DOM aunque no haya contenido: la canaleta y el
         botón de comentar se anclan a él desde ngAfterViewInit. -->
    <div class="doc-shell" #shell [class.is-empty]="loading || loadError">
      <article class="doc-content" #content [innerHTML]="safeHtml"></article>
    </div>
  </section>

  <!-- ─────────── comentarios ─────────── -->
  <!-- `inert` con el panel cerrado: `width: 0` no saca del orden de tabulación, así que
       sin esto se tabula hacia botones y textareas invisibles. -->
  <aside class="doc-panel" [attr.inert]="!panelOpen ? '' : null">
    <div class="doc-panel__inner">

      <!-- Título, filtros y cerrar en UNA sola línea: así el borde inferior de esta
           cabecera queda a la misma altura que el de la cabecera del documento. -->
      <header class="doc-panel__top">
        <h2>{{ panelMode === 'block' ? 'Conversación' : 'Comentarios' }}</h2>

        <div class="doc-panel__filters" *ngIf="panelMode === 'all'">
          <button type="button" [class.is-active]="filter === 'open'" (click)="setFilter('open')">Abiertos</button>
          <button type="button" [class.is-active]="filter === 'resolved'" (click)="setFilter('resolved')">Resueltos</button>
          <button type="button" [class.is-active]="filter === 'all'" (click)="setFilter('all')">Todos</button>
          <button type="button" *ngIf="decisions.length" [class.is-active]="filter === 'decisions'" (click)="setFilter('decisions')">Decisiones</button>
        </div>

        <button type="button" class="doc-icon-btn" (click)="closePanel()" title="Cerrar">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <div class="doc-panel__body" #panelBody>

        <!-- nuevo hilo sobre el bloque activo -->
        <div class="doc-thread doc-thread--new" *ngIf="panelMode === 'block' && canComment" #card [attr.data-anchor]="activeBlockId">
          <p class="doc-anchor">{{ activeBlockText }}</p>
          <div class="doc-composer">
            <textarea id="doc-new-comment" pInputTextarea rows="2" [(ngModel)]="draft"
                      placeholder="Escribe un comentario…"
                      (keydown.control.enter)="createThread()" (keydown.meta.enter)="createThread()"></textarea>
            <button type="button" class="doc-btn doc-btn--primary" [disabled]="!draft.trim() || saving" (click)="createThread()">Comentar</button>
          </div>
        </div>

        <!-- hilos -->
        <article class="doc-thread" *ngFor="let thread of visibleThreads; trackBy: trackByThread" #card [attr.data-anchor]="thread.blockId" [class.is-resolved]="thread.status === 'RESOLVED'">
          <p class="doc-anchor doc-anchor--link" (click)="focusBlock(thread.blockId)" title="Ir al bloque">{{ thread.anchorText }}</p>

          <div class="doc-comment" *ngFor="let comment of thread.comments; trackBy: trackByComment; let first = first" [class.doc-comment--reply]="!first">
            <span class="doc-avatar" [style.background]="avatarColor(comment.author)">{{ initials(comment.author) }}</span>
            <div class="doc-comment__body">
              <div class="doc-comment__who">
                <b>{{ authorName(comment.author) }}</b>
                <span class="doc-role" *ngIf="authorRole(comment.author)">{{ authorRole(comment.author) }}</span>
                <time [title]="exact(comment.createdAt)">{{ ago(comment.createdAt) }}</time>
                <span class="doc-edited" *ngIf="comment.editedAt">editado</span>
              </div>

              <ng-container *ngIf="editingId !== comment._id; else editing">
                <p class="doc-comment__text">{{ comment.content }}</p>
                <div class="doc-comment__actions" *ngIf="isMine(comment.author?._id)">
                  <button type="button" (click)="startEdit(comment._id, comment.content)">Editar</button>
                  <button type="button" (click)="removeComment(comment._id)">Eliminar</button>
                </div>
              </ng-container>

              <ng-template #editing>
                <div class="doc-composer doc-composer--inline">
                  <textarea pInputTextarea rows="2" [(ngModel)]="editDraft"
                            (keydown.control.enter)="saveEdit()" (keydown.meta.enter)="saveEdit()"></textarea>
                  <div class="doc-composer__row">
                    <button type="button" class="doc-btn doc-btn--primary" [disabled]="!editDraft.trim() || saving" (click)="saveEdit()">Guardar</button>
                    <button type="button" class="doc-btn" (click)="cancelEdit()">Cancelar</button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="doc-composer" *ngIf="canComment">
            <textarea pInputTextarea rows="1" [ngModel]="replyDraft[thread._id]" (ngModelChange)="replyDraft[thread._id] = $event"
                      placeholder="Responder…"
                      (keydown.control.enter)="reply(thread)" (keydown.meta.enter)="reply(thread)"></textarea>
            <button type="button" class="doc-btn doc-btn--primary" [disabled]="!replyDraft[thread._id]?.trim() || saving" (click)="reply(thread)">Enviar</button>
          </div>

          <footer class="doc-thread__foot">
            <button type="button" *ngIf="canResolve" (click)="toggleResolve(thread)">
              <i class="fa-solid" [ngClass]="thread.status === 'RESOLVED' ? 'fa-rotate-left' : 'fa-check'"></i>
              {{ thread.status === 'RESOLVED' ? 'Reabrir' : 'Resolver' }}
            </button>
            <span class="doc-thread__count">
              {{ thread.comments.length }} {{ thread.comments.length === 1 ? 'comentario' : 'comentarios' }}
            </span>
          </footer>
        </article>

        <!-- hilos cuyo bloque ya no existe en el documento -->
        <ng-container *ngIf="orphanThreads.length">
          <p class="doc-panel__section" #card>
            Sin bloque
            <i class="fa-solid fa-circle-info" title="El bloque comentado ya no existe en esta versión del manual. La conversación se conserva con el texto al que apuntaba."></i>
          </p>
          <article class="doc-thread doc-thread--orphan" *ngFor="let thread of orphanThreads; trackBy: trackByThread" #card>
            <p class="doc-anchor">{{ thread.anchorText }}</p>
            <div class="doc-comment" *ngFor="let comment of thread.comments; trackBy: trackByComment; let first = first" [class.doc-comment--reply]="!first">
              <span class="doc-avatar" [style.background]="avatarColor(comment.author)">{{ initials(comment.author) }}</span>
              <div class="doc-comment__body">
                <div class="doc-comment__who">
                  <b>{{ authorName(comment.author) }}</b>
                  <span class="doc-role" *ngIf="authorRole(comment.author)">{{ authorRole(comment.author) }}</span>
                  <time [title]="exact(comment.createdAt)">{{ ago(comment.createdAt) }}</time>
                </div>
                <p class="doc-comment__text">{{ comment.content }}</p>
              </div>
            </div>
          </article>
        </ng-container>

        <!-- vacío -->
        <div class="doc-empty" *ngIf="!visibleThreads.length && !orphanThreads.length && panelMode === 'all'">
          <i class="fa-regular fa-comments"></i>
          <p>
            <ng-container *ngIf="filter === 'decisions'; else vacioNormal">
              Ninguna de las {{ progress.total }} decisiones tiene respuesta todavía. Se contestan dejando un comentario en su tarjeta.
            </ng-container>
            <ng-template #vacioNormal>
              No hay comentarios{{ filter === 'open' ? ' abiertos' : filter === 'resolved' ? ' resueltos' : '' }}.
            </ng-template>
          </p>
          <span>Pasa el cursor sobre cualquier bloque del manual para dejar el primero.</span>
        </div>

        <div class="doc-empty doc-empty--tight" *ngIf="!visibleThreads.length && panelMode === 'block' && !canComment">
          <i class="fa-regular fa-comments"></i>
          <p>Este bloque no tiene comentarios.</p>
        </div>

      </div>
    </div>
  </aside>

</div>
